import React from 'react';
import { useSelector } from 'react-redux';
import { string, func } from 'prop-types';

// Import styles
import { Button, Image } from './styles';

const Logo = ({ onClick, ariaLabel, title, src, alt }) => {
	const { isContrast } = useSelector(
		({ wcag_accessibility }) => wcag_accessibility
	);

	return (
		<Button onClick={onClick} aria-label={ariaLabel} title={title}>
			<Image src={src} alt={alt} aria-hidden="true" isContrast={isContrast} />
		</Button>
	);
};

Logo.defaultProps = {
	onClick: () => {},
	ariaLabel: '',
	title: '',
	src: '',
	alt: ''
};

Logo.propTypes = {
	onClick: func.isRequired,
	ariaLabel: string.isRequired,
	title: string.isRequired,
	src: string.isRequired,
	alt: string.isRequired
};

export default Logo;
